/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unit_SqmInputs */

const en_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const es_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const fr_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const de_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const ja_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const zh_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`平方米`)
};

const ar_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`م²`)
};

const id_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const it_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const ru_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`кв.м.`)
};

const pt_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const ko_unit_sqm = /** @type {(inputs: Unit_SqmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

/**
* | output |
* | --- |
* | "m²" |
*
* @param {Unit_SqmInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const unit_sqm = /** @type {((inputs?: Unit_SqmInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unit_SqmInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_unit_sqm(inputs)
	if (locale === "es") return es_unit_sqm(inputs)
	if (locale === "fr") return fr_unit_sqm(inputs)
	if (locale === "de") return de_unit_sqm(inputs)
	if (locale === "ja") return ja_unit_sqm(inputs)
	if (locale === "zh") return zh_unit_sqm(inputs)
	if (locale === "ar") return ar_unit_sqm(inputs)
	if (locale === "id") return id_unit_sqm(inputs)
	if (locale === "it") return it_unit_sqm(inputs)
	if (locale === "ru") return ru_unit_sqm(inputs)
	if (locale === "pt") return pt_unit_sqm(inputs)
	return ko_unit_sqm(inputs)
});